import { render, staticRenderFns } from "./EvaluateDetail.vue?vue&type=template&id=f97ca02e&scoped=true"
import script from "./EvaluateDetail.vue?vue&type=script&lang=js"
export * from "./EvaluateDetail.vue?vue&type=script&lang=js"
import style0 from "./EvaluateDetail.vue?vue&type=style&index=0&id=f97ca02e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97ca02e",
  null
  
)

export default component.exports